import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@shopify/polaris'

import UICard from '../shopifyUI/UICard'

export default class MoveLinkUI extends Component {

  renderLeft () {
    const { resetLinkPosition } = this.props
    return (
      <div>
        <Button size='slim' plain onClick={resetLinkPosition}>
          Undo changes
        </Button>
      </div>
    )
  }

  renderRight () {
    const { moveLinkDone } = this.props
    return (
      <Button primary onClick={moveLinkDone} size='slim'>
        Looks good
      </Button>
    )
  }

  render () {
    return (
      <UICard
        title={'Click and drag to position your product link'}
        footerLeft={this.renderLeft()}
        footerRight={this.renderRight()}
      />
    )
  }
}

MoveLinkUI.propTypes = {
  resetLinkPosition: PropTypes.func.isRequired,
  moveLinkDone: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/productsSlideWizard/MoveLinkUI.js